const CHEAPEST = 'CHEAPEST';
const MEMBER_PRICE_POLICY_DISCOUNTED = 'MEMBER_PRICE_POLICY_DISCOUNTED';
const MEMBER_PRICE_POLICY_UNDISCOUNTED = 'MEMBER_PRICE_POLICY_UNDISCOUNTED';
const MEMBER_PRICE_POLICY_DISCOUNTED_PLUS_COUPON =
  'MEMBER_PRICE_POLICY_DISCOUNTED_PLUS_COUPON';

export {
  CHEAPEST,
  MEMBER_PRICE_POLICY_DISCOUNTED,
  MEMBER_PRICE_POLICY_UNDISCOUNTED,
  MEMBER_PRICE_POLICY_DISCOUNTED_PLUS_COUPON,
};
